import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { ShellPathService } from '../services/shell-path.service';
import { UserService } from '../services/user';

export const practiceEmployeeGuard: CanActivateFn = (route, state) => {
  const userService = inject(UserService);
  const router = inject(Router);
  const shellPath = inject(ShellPathService);

  return userService.getCurrentUser().pipe(
    map((user) => {
      if (!user) {
        return router.createUrlTree(shellPath.prependBase([''], state));
      }

      // Allow practice employees
      if (userService.isPracticeEmployee()) {
        return true;
      }

      // If user is not a practice employee, navigate to home component
      return router.createUrlTree(shellPath.prependBase([''], state));
    }),
    catchError((error) => {
      console.error('Practice employee guard error:', error);
      // On error, redirect to home component
      return of(router.createUrlTree(shellPath.prependBase([''], state)));
    }),
  );
};
